import { WithSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#matches-pseudo}
 */
export class Is extends WithSelector {
    static of(selector) {
        return new Is(selector);
    }
    constructor(selector) {
        super("is", selector, selector.specificity);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context) {
        return this._selector.matches(element, context);
    }
    equals(value) {
        return value instanceof Is && value._selector.equals(this._selector);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (Is) {
    Is.parse = (parseSelector) => WithSelector.parseWithSelector("is", parseSelector, Is.of);
})(Is || (Is = {}));
//# sourceMappingURL=is.js.map